import { render } from "./RecuperoAccountDoppi.vue?vue&type=template&id=e9b82c80&scoped=true"
import script from "./RecuperoAccountDoppi.vue?vue&type=script&lang=js"
export * from "./RecuperoAccountDoppi.vue?vue&type=script&lang=js"

import "./RecuperoAccountDoppi.vue?vue&type=style&index=0&id=e9b82c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b82c80"]])

export default __exports__